<template>
<div class="col-12 text-left">
    <h3 class="p-2">
        <small class="text-muted">User</small>
    </h3>
    <div class="p-2 dropdown-divider"></div>
    <div class="row">
        <div class="form-group col-9">
            <label for="email-input">Email</label>
            <input type="text" class="form-control" v-model="user.email" id="email-input" aria-describedby="email" placeholder="Email">
        </div>
        <div class="form-group col-3">
            <label for="active-input">Active</label>
            <input type="checkbox" class="form-control" v-model="user.status" id="acitve-input" />
        </div>
    </div>
    <div class="row">
        <div class="form-group col-9">
            <label for="name-input">Full Name</label>
            <input type="text" class="form-control" v-model="user.fullName" id="name-input" aria-describedby="name" placeholder="Nama Lengkap">
        </div>
    </div>
    <div class="row">
        <div class="form-group col-9">
            <label for="type-input">Password</label>
            <input type="password" class="form-control" v-model="user.password" id="password-input" aria-describedby="password" placeholder="Password">
        </div>
    </div>
    <br />
    <button type="button" class="btn btn-outline-success" @click="save">Save <i class="far fa-save"></i></button>
    <button type="button" class="btn btn-outline-danger" @click="cancel">Cancel <i class="far fa-window-close"></i></button>
</div>
</template>

<script>
import api from '../../../services/api'
import { User } from '../../../models/user'
import AppLookupField from '../../../components/AppLookupField.vue'
import AppDatatable from '../../../components/AppDatatable.vue'
import AppDatePicker from '../../../components/AppDatePicker.vue'

export default {
    components: {
        AppLookupField, AppDatatable, AppDatePicker
    },
    data() {
        return {
            user: {
                ...User
            }
        }
    },
    async created() {
        if(this.$route.query.id !== undefined) {
            const userApi = api('user')
            this.user = await userApi.getWithParams(this.$route.query.id)
        }
    },
    methods: {
        async save() {
            const userApiAdd = api('/user-register')
            const userApiEdit = api('user')
            if(this.$route.query.id !== undefined) {
                await userApiEdit.update(this.user, this.$route.query.id)
            } else {
                await userApiAdd.create(this.user)
            }
            this.$router.go(-1)
        },
        cancel() {
            this.$router.go(-1)
        }
    }
}
</script>